<template>
  <div id="successpop" v-if="successflag">
    <div class="Model">
      <div
        class="box"
        :style="{
          width: width + 'rem',
          height: height + 'rem',
          backgroundImage: `url(${bg})`,
        }"
      >
        <div class="popone" v-if="poptype == 1">
          <div class="one">
            恭喜您<br />成功领取<span>{{ money }}元</span>优惠
          </div>
          <div class="two">请在2021年{{ time }}(包含)前使用；</div>
          <div class="third">使用方法：提交课程订单时选择使用优惠券。</div>
        </div>
        <div class="poptwo" v-if="poptype == 2">
          <div class="one">恭喜您成功<br />抢占《360°就业通》5折优惠</div>
          <div class="two">请保持电话畅通，咨询老师将</div>
          <div class="third">联系您发放优惠码</div>
        </div>
        <div class="popthree" v-if="poptype == 3">
          <div class="one">恭喜您申请成功！</div>
          <div class="two">请扫码添加运营老师微信，免费领取</div>
          <div class="third">学习路线图</div>
          <img src="../assets/vx2.jpg" alt="" />
        </div>
        <div class="nomore" v-if="poptype == 4">
          <div class="one">温馨提示</div>
          <div class="two">您的小谷币不足，请先积攒小谷币哦</div>
          <div class="button" @click="Ikonw">我知道了</div>
        </div>
        <div class="more" v-if="poptype == 5">
          <div class="one">温馨提示</div>
          <div class="two">您将消耗{{ consumenum }}个小谷币，用于兑换</div>
          <div class="three">“{{ prizename }}”</div>
          <div class="button1" @click="Close()">我再想想</div>
          <div class="button2" @click="Toredeem">去兑换</div>
        </div>
        <div class="popfour" v-if="poptype == 6">
          <div class="one">恭喜您兑换成功！</div>
          <div class="two">请扫码添加运营老师微信，领取好礼</div>
          <img src="../assets/vx3.png" alt="" />
        </div>
        <div class="popfive" v-if="poptype == 7">
          <div class="one">恭喜您获得</div>
          <div class="two">“0.9元学限定大数据课程”资格</div>
          <div class="three">请扫码添加运营老师微信，领取</div>
          <div class="four">课程优惠码</div>
          <img src="../assets/vx1.png" alt="" />
        </div>
        <!--  -->
        <div class="popsix" v-if="poptype == 8">
          <div class="one">恭喜您抢占成功，请保持</div>
          <div class="two">电话畅通</div>
        </div>
        <img @click="Close" class="close" src="../assets/close.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { consumeCoin } from "../api/index";
import { mapState } from "vuex";
export default {
  data() {
    return {
      fistlive: () => {
        if (
          new Date() > new Date("2021/5/10 00:00:00") &&
          new Date() < new Date("2021/5/16 23:59:59")
        ) {
          return true;
        } else {
          return false;
        }
      }, // 第一阶段
      secondlive: () => {
        if (
          new Date() > new Date("2021/5/17 00:00:00") &&
          new Date() < new Date("2021/5/23 23:59:59")
        ) {
          return true;
        } else {
          return false;
        }
      }, //第二阶段
      thirdlive: () => {
        if (
          new Date() > new Date("2021/5/24 00:00:00") &&
          new Date() < new Date("2021/5/31 23:59:59")
        ) {
          return true;
        } else {
          return false;
        }
      }, //第三阶段
      money: 0,
      time: "",
      width: 0,
      height: 0,
      bg: "",
    };
  },
  methods: {
    Close() {
      this.$store.commit("Closesuccesspop");
      this.$mai(2, null, "关闭提示弹窗");
    },
    Ikonw() {
      document.querySelector("#box4").scrollIntoView(true);
      this.Close();
    },
    // 去兑换
    async Toredeem() {
      // this.$store.commit("Openpop", 6);
      const { success } = await consumeCoin(
        {
          activityId: "may_S5C81THFGYKZ",
          userId: localStorage.getItem("uid"),
          activityType: 1,
          operateType: 2,
          convertType: this.convertType,
        },
        localStorage.getItem("sign")
      );
      if (success) {
        this.$store.dispatch("getCoin");
        this.Close()
        this.$store.state.poptype = 6
        setTimeout(() => {
        this.$store.commit("Opensuccesspop");
        }, 200);
        this.$mai(2, null, "去兑换");
      }
    },
  },
  computed: {
    ...mapState([
      "successflag",
      "poptype",
      "consumenum",
      "prizename",
      "convertType",
    ]),
  },
  watch: {
    poptype(value) {
      switch (value) {
        case 1:
          this.bg = require("../assets/success.png");
          this.width = 7.2;
          this.height = 6.58;
          if (this.fistlive()) {
            (this.money = 2000), (this.time = "5月16日");
          } else if (this.secondlive()) {
            (this.money = 1200), (this.time = "5月23日");
          } else if (this.thirdlive()) {
            (this.money = 500), (this.time = "5月31日");
          }
          break;
        case 2:
          this.width = 7.2;
          this.height = 6.09;
          this.bg = require("../assets/success.png");
          break;
        case 3:
          this.width = 7.2;
          this.height = 8.93333;
          this.bg = require("../assets/success.png");
          break;
        case 4:
          this.width = 7.2;
          this.height = 7.2;
          this.bg = require("../assets/nomore.png");
          break;
        case 5:
          this.width = 7.2;
          this.height = 7.2;
          this.bg = require("../assets/more.png");
          break;
        case 6:
          this.width = 7.2;
          this.height = 8.466;
          this.bg = require("../assets/success.png");
          break;
        case 7:
          this.width = 7.2;
          this.height = 9.28;
          this.bg = require("../assets/success.png");
          break;
        case 8:
          this.width = 7.2;
          this.height = 5.066;
          this.bg = require("../assets/success.png");
          break;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.Model {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
  .box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    border-radius: 10px;
    // background-image: url("../assets/success.png");
    background-position: center 60px;
    background-repeat: no-repeat;
    background-size: 200px 150px;
    .close {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      bottom: -80px;
      width: 52px;
      height: 52px;
    }
    .popone {
      .one {
        margin-top: 232px;
        text-align: center;
        font-family: PingFangSC-Semibold;
        font-size: 33px;
        font-stretch: normal;
        color: #222222;
        span {
          color: #ff282b;
          font-weight: bold;
        }
      }
      .two {
        text-align: center;
        margin-top: 29px;
        font-family: PingFangSC-Regular;
        font-size: 26px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
        &::before {
          content: "1.";
          display: inline-block;
        }
      }
      .third {
        margin: 0 auto;
        max-width: 424px;
        margin-top: 10px;
        font-family: PingFangSC-Regular;
        font-size: 26px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
        &::before {
          content: "2.";
          display: inline-block;
        }
      }
    }
    .poptwo {
      text-align: center;
      .one {
        margin-top: 232px;
        font-family: PingFangSC-Semibold;
        font-size: 33px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      .two {
        margin-top: 30px;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      .third {
        @extend .two;
        margin-top: 10px;
      }
    }
    .popthree {
      text-align: center;
      .one {
        margin-top: 232px;
        font-family: PingFangSC-Semibold;
        font-size: 33px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      .two {
        margin-top: 30px;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      .third {
        @extend .two;
        margin-top: 10px;
      }
      img {
        display: block;
        margin: 0 auto;
        margin-top: 34px;
        width: 200px;
        height: 200px;
      }
    }
    .nomore {
      text-align: center;
      .one {
        margin-top: 228px;
        font-family: PingFangSC-Semibold;
        font-size: 33px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      .two {
        font-family: PingFangSC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
        margin-top: 30px;
      }
      .button {
        margin: 0 auto;
        margin-top: 90px;
        width: 420px;
        height: 70px;
        background-image: url("../assets/btn.png");
        background-size: 100% 100%;
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 70px;
        color: #5530fd;
      }
    }
    .more {
      text-align: center;
      .one {
        margin-top: 228px;
        font-family: PingFangSC-Semibold;
        font-size: 33px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      .two {
        margin-top: 30px;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      .three {
        @extend .two;
        margin-top: 10px;
      }
      .button1 {
        box-sizing: border-box;
        float: left;
        margin-left: 66px;
        margin-top: 35px;
        width: 192px;
        height: 70px;
        background-image: url("../assets/btn.png");
        background-size: 100% 100%;
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 70px;
        color: #5530fd;
        border-radius: 12px;
        border: solid 2px #2549ff;
      }
      .button2 {
        @extend .button1;
        margin-left: 29px;
      }
    }
    .popfour {
      text-align: center;
      .one {
        margin-top: 232px;
        font-family: PingFangSC-Semibold;
        font-size: 33px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      .two {
        margin-top: 30px;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      img {
        display: block;
        margin: 0 auto;
        margin-top: 30px;
        width: 200px;
        height: 200px;
      }
    }
    .popfive {
      text-align: center;
      .one {
        margin-top: 237px;
        font-family: PingFangSC-Semibold;
        font-size: 33px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      .two {
        @extend .one;
        margin-top: 0px;
      }
      .three {
        margin-top: 15px;
        font-family: PingFangSC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
      }
      .four {
        @extend .three;
        margin-top: 0px;
      }
      img {
        display: block;
        margin: 0 auto;
        margin-top: 20px;
        width: 200px;
        height: 200px;
      }
    }
    .popsix {
      text-align: center;
      .one {
        font-family: PingFangSC-Semibold;
        font-size: 33px;
        font-weight: normal;
        font-stretch: normal;
        color: #222222;
        margin-top: 244px;
      }
      .two {
        @extend .one;
        margin-top: 0;
      }
    }
  }
}
</style>